import React from 'react';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';

interface IQuizTopicProps {
  settings: any;
}

const QuizTopic: React.FunctionComponent<IQuizTopicProps> = ({ settings }) => (
  <TopicContainer className="quiz">
    <TopicItem className="course-landing intro" id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem id="2">
      <Section1 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default QuizTopic;
